var confirmTriggers = [];
var confirmDismissTriggers = [];
export var registerConfirmTrigger = function (trigger) {
    confirmTriggers.push(trigger);
};
export var registerConfirmDismissTrigger = function (trigger) {
    confirmDismissTriggers.push(trigger);
};
export var confirm = function (confirm) {
    confirmTriggers.forEach(function (confirmTrigger) {
        confirmTrigger(confirm);
    });
};
// Closes a dialog opened with `confirm` while it is still unanswered, e.g.
// because what it asks about is gone. A dialog that was already answered or
// replaced by another one stays as it is.
// INFO: only apps whose confirm provider registers a dismiss trigger close
// the dialog; elsewhere this does nothing.
export var dismissConfirm = function (confirmToDismiss) {
    confirmDismissTriggers.forEach(function (dismissTrigger) {
        dismissTrigger(confirmToDismiss);
    });
};
